import baseline from './baseline';
import is7008TwoStepV2 from './7008-two-step-v2';
import is6568iOSIAPTest from './6568-ios-iap-test';
import is7005GooglePlayTest from './7005-google-play-test';
import is1740AA45RIQ from './1740-45-riq-two-step';

export default {
  baseline,
  '7008-two-step-v2': is7008TwoStepV2,
  '6568-ios-iap-test': is6568iOSIAPTest,
  '7005-google-play-test': is7005GooglePlayTest,
  '1740-45-riq-two-step': is1740AA45RIQ,
};
